import { render, staticRenderFns } from "./notBuy.vue?vue&type=template&id=c5ece16a&scoped=true&"
import script from "./notBuy.vue?vue&type=script&lang=js&"
export * from "./notBuy.vue?vue&type=script&lang=js&"
import style0 from "./notBuy.vue?vue&type=style&index=0&id=c5ece16a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ece16a",
  null
  
)

export default component.exports